<template>
  <Dialog ref="dialog" type="buy" :show="$bus.buyDialog.show" :title="$bus.transify['FLIP_CONGRATULATIONS']">
    <template v-slot:dialog-content v-if="$bus.buyDialog.show">
      <Item class="item" type="reward" :nums="$bus.activePrize.item_num" :imgSrc="$bus.activePrize.item_img" :name="$bus.activePrize.item_name">
        <ff-mark class="item-mask"
          :type="getType"
          points="15, 3 3, 15 3, 32 32, 3">
          <div class="mark-text" :class="getMarkTextClass">
            <i class="diamond"></i>
            <span class="text bebas-font">{{ getDiscountText }}</span>
          </div>
        </ff-mark>
      </Item>
      <div class="price-content">
        <div class="price">
          <i class="diamond"></i>
          <span class="gems bebas-font">{{getPrice($bus.activePrize.price)}}</span>
        </div>
        <div class="init-price grey">
          <span class="gems bebas-font">{{$bus.activePrize.price}}</span>
        </div>
      </div>
      <ff-button type="confirm" @btnEvent="purchase">
        <span class="confirm-btn-text bebas-font">{{$bus.transify['LUCKY_PURCHASE']}}</span>
      </ff-button>
      <p class="confirm-tips bebas-font">{{ $bus.activePrize.to_token === 1 ? $bus.transify['UNIQUE_REDEEM_ALREADY_HAVE'] : $bus.transify['COMMON_TIPS_ITEM'] }}</p>
    </template>
  </Dialog>
</template>

<script>
import Item from '@/components/common/Item.vue'
import ffButton from '@/components/common/Button.vue'
import Dialog from '@/components/common/Dialog.vue'
import ffMark from '@/components/common/Mark.vue'

export default {
  components: {
    Item,
    ffButton,
    Dialog,
    ffMark
  },
  computed: {
    getType () {
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0 ? 'light' : 'normal'
    },
    getMarkTextClass () {
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0 ? 'diamond-type' : ''
    },
    getDiscountText () {
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0 ? currentDiscount.discount : -currentDiscount.discount + '%'
    }
  },
  methods: {
    getCurrentDiscount () {
      if (!this.$bus.discountPool || this.$bus.enable === -1) {
        return {}
      }
      return this.$bus.discountPool.find(item => item.pk === this.$bus.enable)
    },
    getPrice (price) {
      if (this.$bus.enable === -1) {
        return price
      }
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0 ? currentDiscount.discount : Math.floor(price * (100 - currentDiscount.discount) / 100)
    },
    purchase () {
      this.$bus.addGA('purchase-button', 'click')
      const activePrize = this.$bus.activePrize
      const cost = this.getPrice(activePrize.price)
      this.$api.purchase({
        pk: activePrize.pk,
        dpk: this.$bus.enable,
        cost
      }).then(res => {
        this.$bus.clickSound = true
        this.$bus.gems -= cost
        this.$bus.finish = res.data.finish
        if (this.$bus.purchased.indexOf(this.$bus.activePrize.pk) === -1) {
          this.$bus.purchased.push(this.$bus.activePrize.pk)
        }

        // 是否需要重置转盘
        const index = this.$bus.discountPool.findIndex(item => item.pk === this.$bus.enable)
        this.$bus.discountPool[index].status = 2
        // TODO：是否可以重置
        if (this.$bus.discountPool.every(item => item.status === 2) && this.$bus.finish === 0) {
          this.$bus.discountPool = this.$bus.formatDiscountList(this.$bus.originDiscountPool.slice(), [], -1)
          this.$bus.deltaAngle = 45
          this.$bus.prevRotateIndex = 0
        }
        // 重置奖池
        this.$bus.rewardPool = this.$bus.rewardPool.map(item => ({...item, purchased: this.$bus.purchased.indexOf(item.pk) !== -1}))

        this.$bus.buyDialog.show = false
        // 是否是大奖
        const currentDiscount = this.getCurrentDiscount()
        this.$bus.enable = -1
        if (currentDiscount.discountType === 0) {
          this.$bus.currentShareDiscount = currentDiscount
          this.$bus.shareInfo.show = true
        } else {
          this.$bus.handleToast(true, 'LUCKY_BUY_SUCCESS')
          this.$bus.activePrize = {}
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  @include px2res(margin, 0, 20);
  .item-nums {
    color: #FFDE00;
    font-weight: 500;
    position: absolute;
    z-index: 3;
    @include px2res(top, 12);
    @include px2res(right, 22);
    @include px2res(font-size, 30);
  }
}
.item.light {
  animation: none !important;
  box-shadow: none !important;
}
.confirm-btn-text {
  flex: auto;
  color: #000;
  @include px2res(height, 60);
  @include px2res(line-height, 66);
}
.confirm-tips {
  color: #A1A1A1;
  text-align: center;
  @include px2res(font-size, 24);
  @include px2res(margin-top, 16);
  text-transform: uppercase;
  line-height: 1;
}
.mark-text {
  top: 18%;
  left: 10%;
  @include px2res(width, 74);
  @include px2res(height, 30);
  .diamond {
    @include px2res(margin-right, 2);
  }
}
.price-content {
  height: auto;
  @include px2res(margin, 10, auto, 18);
  .diamond {
    @include px2res(width, 30);
    @include px2res(height, 27);
    @include px2res(margin, 1, 5, 0, 0);
  }
  .gems {
    @include px2res(font-size, 36);
  }
}
.init-price.grey .gems {
  @include px2res(font-size, 24);
}
</style>



// WEBPACK FOOTER //
// src/components/buy/index.vue